import 'twin.macro';
import Image from '@leuven2030/framework/Image/Image';
import PrismicText from '@leuven2030/framework/Prismic/PrismicText';
import React from 'react';
import { css } from '@emotion/react';

const ContentFeature = ({ data: { title, image }, fields }) => {
  return (
    <div tw="space-y-3 py-6">
      <h2 tw="text-xl text-gray-500 uppercase">{title}</h2>
      <div tw="grid grid-cols-1 gap-12 sm:(grid-cols-2) ">
        <div>
          <Image
            tw="w-full h-auto shadow-lg rounded-md overflow-hidden"
            src={image.url}
            width={400}
            height={300}
            imgixParams={{
              crop: 'faces',
              fit: 'crop'
            }}
          />
        </div>
        <div tw="prose space-y-6">
          {fields.map(({ text }, index) => (
            <div tw="flex items-start space-x-3" key={index}>
              <div tw="w-3 h-3 bg-gray-200 rounded-full flex-shrink-0 my-2" />
              <PrismicText
                text={text}
                css={css`
                  p {
                    margin: 0 !important;
                  }
                `}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
ContentFeature.type = 'feature';

export default ContentFeature;
